import { DashboardTitle } from 'components/Titles';
import { useReport } from 'hooks/useReport';
import { FC } from 'react';

import { Grid, Typography } from '@mui/material';

import { ReportList } from './ReportList';

export const Report: FC = () => {
  const { report, loadingList } = useReport();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DashboardTitle title="GESTÃO DE COLABORADORES - RELATÓRIO" />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Resumo anual</Typography>
      </Grid>

      <Grid item xs={12} style={{ paddingLeft: 0 }}>
        <ReportList list={report} loading={loadingList} />
      </Grid>
    </Grid>
  );
};

